import { StatusContainer } from '@servicetitan/financing-utils-shared';
import { LoanDetails } from './LoanDetails';
import UnderReviewIllustration from '../../common/illustrations/updating.svg';
import { useProviderConfig } from '@servicetitan/financing-workflow-shared';

export const UnderReview = () => {
    const providerConfig = useProviderConfig();

    return (
        <StatusContainer
            headline={providerConfig.underReviewHeadline ?? 'Your application is under review'}
            message={providerConfig.underReviewMessage}
            image={UnderReviewIllustration}
        >
            <LoanDetails hideDetails />
        </StatusContainer>
    );
};
